<template>
    <Tooltip :text="$t('dash.beta.help')" :position="position" class="beta-badge-wrap">
        <span class="beta-badge">{{ $t('dash.overview.beta') }}</span>
    </Tooltip>
</template>

<script>
import Tooltip from './../tooltip/tooltipInit.vue'

// Mention « Bêta » à côté d'un titre de section (même style que l'accueil)
export default {
    name: 'BetaBadge',

    components: { Tooltip },

    props: {
        position: {
            type: String,
            default: 'bottom'
        },
    },
};
</script>

<style lang="scss" scoped>
.beta-badge-wrap {
    display: inline-flex;
    vertical-align: middle;
    margin-left: 8px;
}

.beta-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 10px;
    background: #f6f1fa;
    border: 1px solid #e0d0ea;
    color: #b64985;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.4;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    white-space: nowrap;
}
</style>
